import React from 'react'
import { Form, Typography } from '@s4l/ds'
import { IconTrash } from '@s4l/icons/IconTrash'
import { useS4LContext } from '@s4l/react-context'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import {
  SEARCH_FILTER_ACCOMMODATION_TYPES,
  type SearchFilterAccommodationType,
} from '@s4l/stayforlong/kernel/ListOfAccommodation'
import { useSearchMetadata } from '../useSearchMetadata'

const FilterAccommodation = () => {
  const { i18n } = useS4LContext()
  const { searchMetadata } = useSearchMetadata()

  const accommodationMessages: Record<SearchFilterAccommodationType, string> = {
    HOTEL: i18n.formatMessage({ id: 'global.hotel' }),
    RESORT: i18n.formatMessage({ id: 'global.resort' }),
    APARTMENT: i18n.formatMessage({ id: 'global.apartment' }),
    VILLA: i18n.formatMessage({ id: 'global.villa' }),
    HOMES: i18n.formatMessage({ id: 'global.homes' }),
    HOSTEL: i18n.formatMessage({ id: 'global.hostel' }),
    APTHOTEL: i18n.formatMessage({ id: 'global.apthotel' }),
  }

  const visibleAccommodations = SEARCH_FILTER_ACCOMMODATION_TYPES.slice(0, 5)
  const collapsedAccommodations = SEARCH_FILTER_ACCOMMODATION_TYPES.slice(5)

  return (
    <Form.Fieldset>
      <Form.Legend>{i18n.formatMessage({ id: 'global.accommodation' })}</Form.Legend>
      <Form.ClearButton icon={<IconTrash />}>
        {i18n.formatMessage({ id: 'serp.filter-clear' })}
      </Form.ClearButton>
      {visibleAccommodations.map(accommodation => {
        const count = searchMetadata?.accommodationTypes?.getByKey(accommodation)?.count ?? 0

        return (
          <Form.Label key={`accommodation-${accommodation}`}>
            {accommodationMessages[accommodation]}
            {searchMetadata && (
              <Typography variant="caption" size="l" color="neutral-800">
                {count}
              </Typography>
            )}
            <Form.Checkbox
              disabled={searchMetadata && !count}
              name="accommodationTypes"
              multiple
              trueValue={accommodation.toLowerCase()}
            />
          </Form.Label>
        )
      })}

      <Form.Collapsible
        textMore={i18n.formatMessage({ id: 'global.show-all' })}
        textLess={i18n.formatMessage({ id: 'global.show-less' })}
      >
        {collapsedAccommodations.map(accommodation => {
          const count = searchMetadata?.accommodationTypes?.getByKey(accommodation)?.count ?? 0
          return (
            <Form.Label key={`accommodation-${accommodation}`}>
              {accommodationMessages[accommodation]}
              {searchMetadata && (
                <Typography variant="caption" size="l" color="neutral-800">
                  {count}
                </Typography>
              )}
              <Form.Checkbox
                disabled={searchMetadata && !count}
                name="accommodationTypes"
                multiple
                trueValue={accommodation.toLowerCase()}
              />
            </Form.Label>
          )
        })}
      </Form.Collapsible>
    </Form.Fieldset>
  )
}

FilterAccommodation.displayName = 'SearchFilters.FilterAccommodation'
export default withErrorBoundary(FilterAccommodation)
